import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface ReferenceInstrumentIdFormFieldProps {
  instruments?: { label: string; value: number }[]
  loading?: boolean
  disabled?: boolean
}

export const ReferenceInstrumentIdFormField: React.FC<ReferenceInstrumentIdFormFieldProps> = ({
  instruments,
  loading,
  disabled,
}) => {
  const { control, setValue } = useFormContext<{ reference_instrument_id: number }>()

  return (
    <FormField
      name="reference_instrument_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Reference Instrument</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={field.value?.toString()}
              disabled={disabled}
              loading={loading}
              options={instruments?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
              placeholder={'Select an Instrument'}
              setValue={(val) =>
                setValue('reference_instrument_id', parseInt(val), {
                  shouldValidate: true,
                })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
